export type AuthProvider = "microsoft" | "google";
export const availableAuthProviders = ["microsoft", "google"] as const;
